<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-5">
    <div style="max-width:640px">
      <h3 class="mb-1">AI Modell Config</h3>
      <div style="font-style: italic; color:var(--bo-muted)">
        AI-modellserver for Website Builder (vLLM/Qwen, OpenAI-kompatibel). Lagres i Couchbase; API-nøkkelen
        lagres <strong>kryptert</strong>. Endringer tas i bruk uten restart.
      </div>

      <div class="alert mt-3 py-2" :class="config.live ? 'alert-success' : 'alert-secondary'" style="font-size:0.88rem">
        <template v-if="config.live">
          <strong>Live</strong> — modellserver satt. Prompt → generér bruker den ekte modellen.
        </template>
        <template v-else>
          <strong>Mock-modus</strong> — tom server-URL. Systemet bruker den deterministiske nøkkelord-mocken
          (ingen GPU). Fyll inn server-URL for å gå live (v2.0).
        </template>
      </div>

      <config-lock ref="lock" :configured="isConfigured">
      <div class="mt-4">
        <label class="form-label mb-1 sm-label">Server-URL (vLLM/Qwen base)</label>
        <input class="form-control" type="text" v-model="form.serverUrl" placeholder="https://… (tom = mock)" autocomplete="off" />
        <div style="color:var(--bo-muted); font-size:0.78rem" class="mt-1">
          Kalles kun fra CagistaServices (aldri fra klienten). <code>/v1/chat/completions</code> legges på automatisk.
        </div>
      </div>

      <div class="row g-3 mt-1">
        <div class="col-md-6">
          <label class="form-label mb-1 sm-label">Modellnavn</label>
          <input class="form-control" type="text" v-model="form.modelName" placeholder="qwen" autocomplete="off" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 sm-label">API-nøkkel</label>
          <div class="mb-1">
            <span class="badge" :class="config.apiKeySet ? 'bg-success' : 'bg-secondary'">
              {{ config.apiKeySet ? 'Konfigurert ✓' : 'Ikke satt' }}
            </span>
          </div>
          <div style="position:relative">
            <input :type="showKey ? 'text' : 'password'" class="form-control" style="padding-right:38px"
                   v-model="form.apiKey" autocomplete="new-password"
                   :placeholder="config.apiKeySet ? '•••• (lagret — la stå tomt)' : 'Bearer-token (valgfritt)'" />
            <button type="button" @click="showKey = !showKey" :title="showKey ? 'Skjul' : 'Vis'"
                    style="position:absolute; right:10px; top:50%; transform:translateY(-50%); border:none; background:none; color:var(--bo-muted); cursor:pointer; padding:0; line-height:1;">
              <font-awesome-icon :icon="['fas', showKey ? 'eye-slash' : 'eye']" />
            </button>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex align-items-center gap-3">
        <button class="bo_btn" @click="save" :disabled="saving">{{ saving ? 'Lagrer…' : 'Lagre' }}</button>
        <span v-if="message" :class="error ? 'text-danger' : 'text-success'">{{ message }}</span>
      </div>
      </config-lock>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfigLock from "@/components/other/ConfigLock";
import SettingsService from "@/services/settings/SettingsService";

export default {
  name: "SiteModelConfig",
  components: { LoadingSpinner, ConfigLock },
  computed: {
    // Already configured (→ starts locked): the model server URL is set (live) or an API key is stored.
    isConfigured() { return !!(this.config.live || this.config.apiKeySet); }
  },
  data() {
    return {
      loading: true,
      config: {},
      form: { serverUrl: "", modelName: "", apiKey: "" },
      showKey: false,
      saving: false,
      message: "",
      error: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      SettingsService.getSiteModelConfig().then(
        (response) => {
          this.config = response.data || {};
          this.form.serverUrl = this.config.serverUrl || "";
          this.form.modelName = this.config.modelName || "";
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke hente konfigurasjon.");
        }
      );
    },
    save() {
      this.saving = true;
      this.message = "";
      this.error = false;
      SettingsService.saveSiteModelConfig({
        serverUrl: this.form.serverUrl, modelName: this.form.modelName, apiKey: this.form.apiKey
      }).then(
        (response) => {
          this.saving = false;
          this.config = response.data || {};
          this.form.apiKey = "";
          this.showKey = false;
          this.error = false;
          this.message = "Lagret ✓ — tas i bruk umiddelbart (ingen restart).";
          this.$refs.lock.relock();   // re-lock after a successful save
        },
        (error) => {
          this.saving = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke lagre konfigurasjon.");
        }
      );
    },
    errMsg(error, fallback) {
      const data = error && error.response ? error.response.data : null;
      return (data && data.error) || fallback;
    }
  }
};
</script>

<style scoped>
.sm-label {
  font-size: 0.85rem;
  color: var(--bo-muted);
}
</style>
